var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-component-modal',{attrs:{"showModal":_vm.showModal,"hideFooterButtons":true,"modalSize":_vm.modalSize,"onClickCancel":_vm.onClickCancel},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('img',{attrs:{"src":_vm.image,"alt":"","title":""}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }